export default {
  scaleSheetProfiles: [],
  ticketBooks: [],
  loading: false
}
